(function () {
    'use strict';

    angular
        .module('franchisee-portal.components')
        .controller('CommunicatesController', CommunicatesController);

    /** @ngInject */
    function CommunicatesController($scope, $rootScope, $state, $stateParams, $timeout, AuthenticationService, CommunicateService, HelperService, DATA_EVENTS) {
        const vm = this;

        let communicatesSkip;
        let communicatesTake;

        vm.closeCommunicate = () => {
            if (vm.selectedCommunicate.ReadingConfirmation && !vm.selectedCommunicate.HasPersonRead)
                postAccessLog(vm.selectedCommunicate);

            $state.transitionTo('app-master.full-screen.communicates');

            vm.selectedCommunicate = null;
        }

        vm.closeEditFileFolderModal = () => {
            if (vm.selectedCommunicate.ReadingConfirmation && !vm.selectedCommunicate.HasPersonRead)
                postAccessLog(vm.selectedCommunicate);

            $('#modalReadCommunicate').modal('hide');
        }

        vm.loadMoreCommunicates = () => {
            if (vm.isLoading)
                return;

            getCommunicates(false);
        }

        vm.openCommunicate = communicate => {
            if (vm.selectedCommunicate && vm.selectedCommunicate.Id == communicate.Id)
                return;

            HelperService.startLoading('.communicate-body');

            let userData = AuthenticationService.getUserData();

            if ($stateParams.communicateUrl && !communicate) {
                CommunicateService
                    .getByUrl($stateParams.communicateUrl, userData.Id, userData.Responsibility.Id)
                    .then(getCommunicateSuccessCallback, getCommunicateErrorCallback)
            } else {
                CommunicateService
                    .getById(communicate.Id, userData.Id)
                    .then(getCommunicateSuccessCallback, getCommunicateErrorCallback)
            }
        }

        let removeWatchUnit = $rootScope.$on(DATA_EVENTS.SELECTED_UNIT_CHANGE, () => {
            init();
        })

        $scope.$on('$destroy', () => {
            removeWatchUnit();
        })

        init();

        function getCommunicateSuccessCallback(success) {
            vm.selectedCommunicate = success;

            if (success.ReadingConfirmation && !success.HasPersonRead) {
                $timeout(() => {
                    $('#modalReadCommunicate').modal('show');
                })
            } else if (!success.HasPersonRead)
                postAccessLog(vm.selectedCommunicate);

            if ($stateParams.communicateUrl != success.Url) {
                $state.go('app-master.full-screen.communicates', {
                    communicateUrl: success.Url
                });
            }

            $timeout(() => {
                $.fn.scrollbar && $('.scrollable-communication-body').scrollbar({
                    ignoreOverlay: false
                });

                HelperService.stopLoading('.communicate-body');
            })
        }

        function getCommunicateErrorCallback(error) {
            HelperService.errorCallback(error);
            HelperService.stopLoading('.communicate-body');
        }

        function postAccessLog(readCommunicate) {
            let userData = AuthenticationService.getUserData();

            CommunicateService
                .postAccessLog({
                    CommunicateId: vm.selectedCommunicate.Id,
                    PersonId: userData.Id
                })
                .then(() => {
                    let communicate = vm.communicates.find(x => x.Id == readCommunicate.Id);

                    communicate.HasPersonRead = true;
                });
        }

        function getCommunicates(shouldOpenCommunicate) {
            vm.isLoading = true;

            HelperService.startLoading('.communicates-holder');

            const parameters = prepareParameters();
            let userData = AuthenticationService.getUserData();

            parameters.ResponsibilityId = userData.Responsibility.Id;

            CommunicateService
                .getAllByParameters(parameters, userData.Id)
                .then(success => {
                    vm.hasMoreCommunicates = success.NumberOfPages > 1;
                    vm.communicates = vm.communicates.concat(success.Communicates);

                    communicatesSkip += communicatesTake;

                    $timeout(() => {
                        $.fn.scrollbar && $('.scrollable').scrollbar({
                            ignoreOverlay: false
                        });

                        vm.isLoading = false;
                        HelperService.stopLoading('.communicates-holder');

                        if ($stateParams.communicateUrl && shouldOpenCommunicate)
                            vm.openCommunicate();
                    })
                }, error => {
                    HelperService.errorCallback(error);
                })
        }

        function prepareParameters() {
            return {
                PerPage: communicatesSkip,
                Skip: communicatesSkip,
                OrderBy: 'RegistrationDate',
                OrderDescending: true,
                Active: true
            }
        }

        function init() {
            vm.communicates = [];
            vm.isLoading = false;
            vm.selectedCommunicate;

            communicatesSkip = 0;
            communicatesTake = 10;

            $rootScope.fullScreenApp = true;

            getCommunicates(true);
        }
    }
}());